import React from "react";
import PropTypes from "prop-types";
import LoadMore from "~/Components/Global/LoadMore";

const PER_PAGE = 30;

class LoadMoreContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: 1, hasMore: false, filter: this.props.filter, items: [] };
  }
  componentDidMount() {
    this.fetch(this.props.slug, 1);
  }

  pagination = (e) => {
    e.stopPropagation();
    this.fetch(this.props.slug, this.state.page);
  };

  fetch = () => {
    this.props.request(this.state.page).then(({ data }) => {
      const hasMore = data.length === PER_PAGE;
      const { items } = this.state;
      data.map((t) => items.push(t));
      this.setState({ items, page: this.state.page + 1, hasMore });
    });
  };

  render = () => {
    const { items } = this.state;
    const { type, hasMore } = this.state;
    const { loading, render } = this.props;
    if (!loading && (!items || items.length === 0)) {
      return null;
    }
    const loadMore = <LoadMore loading={loading} hasMore={hasMore} items={items} pagination={this.pagination} />;
    const { items: posts, ...data } = this.state;
    return render({ items, loadMore, data, loading });
  };
}

LoadMoreContainer.propTypes = {
  filter: PropTypes.string.isRequired,
};
LoadMoreContainer.defaultProps = {};
export default LoadMoreContainer;
